/**
 * 电子处方
 */
var basePath = 'e-prescribing'

const ePrescribing = [
  {
    path: `${basePath}/drugstore-list`,
    name: `${basePath}/drugstore-list`,
    meta: {
      title: '药店查询',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/e-prescribing/drugstore-list.vue'], resolve)
  },
  {
    path: `${basePath}/details`,
    name: `${basePath}/details`,
    meta: {
      title: '电子处方查询',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/e-prescribing/details.vue'], resolve)
  }
]

export default ePrescribing
